// export enum PayoutSource {
//   AP = "PayoutSource_AP",
//   AR = "PayoutSource_AR"

import { PayoutPreferences } from "@wingspanhq/payments/dist/interfaces";

// }
export type PayoutSource = "PayoutSource_AP" | "PayoutSource_AR";

export enum PayoutStatus {
  Created = "Created",
  Clearing = "Clearing",
  Failed = "Failed",
  Complete = "Complete"
}

export const PayoutTypeEnum = {
  PayoutType_Instant: "Instant" as PayoutPreferences,
  PayoutType_Standard: "Standard" as PayoutPreferences
};
export type PayoutType = keyof typeof PayoutTypeEnum;

// export enum PayoutType {
//   Instant = 0,
//   Standard = 1
// }

export interface ExternalDestination {
  destinationType: string; // queryAccount.data?.institutionId = ins_7
  destinationId: string;
  name?: string;
  institutionName?: string;
  mask?: string;
}

export interface PayoutItem {
  sourceId: string;
  sourceType: string;
  amount: number;
  description?: string;
  associatedResourceId?: string;
  associatedResourceType?: string;
  transactionDate?: Date;
  _id?: string; //!was not in BE Interfaces but exist on PROD
}

export interface PayoutTransfer {
  fundsMovementId: string;
  amount: number;
  destination?: ExternalDestination;
  status?: PayoutStatus;
  traceId?: string;
  _id?: string; //!was not in BE Interfaces but exist on PROD
}

export interface PayoutEvents {
  processedAt?: Date;
  lastFailedAt?: Date;
  nextRetryAt?: Date;
}

export interface Payout {
  _id?: string; //!was not in BE Interfaces but exist on PROD
  userRoles?: any; //!was not in BE Interfaces but exist on PROD
  labels?: any; //!was not in BE Interfaces but exist on PROD
  eventActors?: any; //!was not in BE Interfaces but exist on PROD
  __v?: any; //!was not in BE Interfaces but exist on PROD

  payoutId: string;
  payoutItems: PayoutItem[];
  taxWithholdingTransfer?: PayoutTransfer | {}; //! {} was not in BE Interfaces but exist on PROD
  bankingFundsTransfer?: PayoutTransfer | {}; //! {} was not in BE Interfaces but exist on PROD
  externalFundsTransfers: PayoutTransfer[];
  currency: string;
  payoutType?: PayoutType; //! {} should be mandatory in BE Interfaces but not exist on PROD
  createdAt: Date;
  updatedAt: Date;
  retryCount?: number;
  status: PayoutStatus;
  events: PayoutEvents;
  isSettlement: boolean;
  settlementPeriodStart?: Date;
  settlementPeriodEnd?: Date;
  currentPeriodBalance?: number;
  futureDebits?: number;
  payoutSource?: PayoutSource;
  userId: string;
}

// export const mockPayouts: Payout[] = [
//   {
//     payoutId: "payout1",
//     payoutItems: [
//       {
//         sourceId: "source1",
//         sourceType: "AP",
//         amount: 1500.0,
//         description: "Payment for services",
//         associatedResourceId: "res1",
//         associatedResourceType: "Invoice",
//         transactionDate: new Date("2024-01-01")
//       }
//     ],
//     taxWithholdingTransfer: {
//       fundsMovementId: "funds1",
//       amount: 200.0,
//       destination: {
//         destinationType: "BankAccount",
//         destinationId: "dest1",
//         name: "John Doe",
//         institutionName: "Big Bank",
//         mask: "1234"
//       },
//       status: PayoutStatus.Clearing,
//       traceId: "trace1"
//     },
//     bankingFundsTransfer: {
//       fundsMovementId: "funds2",
//       amount: 1300.0,
//       destination: {
//         destinationType: "BankAccount",
//         destinationId: "dest2",
//         name: "Jane Smith",
//         institutionName: "Small Bank",
//         mask: "5678"
//       },
//       status: PayoutStatus.Created,
//       traceId: "trace2"
//     },
//     externalFundsTransfers: [
//       {
//         fundsMovementId: "funds4",
//         amount: 2250.0,
//         destination: {
//           destinationType: "BankAccount",
//           destinationId: "dest3",
//           name: "Company ABC",
//           institutionName: "Corporate Bank",
//           mask: "7890"
//         },
//         status: PayoutStatus.Failed,
//         traceId: "trace4"
//       }
//     ],
//     currency: "USD",
//     payoutType: PayoutTypeEnum.Instant,
//     createdAt: new Date("2024-01-02"),
//     updatedAt: new Date("2024-01-03"),
//     retryCount: 1,
//     status: PayoutStatus.Failed,
//     events: {
//       processedAt: new Date("2024-01-04"),
//       lastFailedAt: new Date("2024-01-03"),
//       nextRetryAt: new Date("2024-01-05")
//     },
//     isSettlement: false,
//     settlementPeriodStart: new Date("2024-01-01"),
//     settlementPeriodEnd: new Date("2024-01-31"),
//     currentPeriodBalance: 5000.0,
//     futureDebits: 1000.0,
//     payoutSource: PayoutSource.AR,
//     userId: "user1"
//   },
//   {
//     payoutId: "payout2",
//     payoutItems: [
//       {
//         sourceId: "source2",
//         sourceType: "AR",
//         amount: 2500.0,
//         description: "Refund for order",
//         associatedResourceId: "res2",
//         associatedResourceType: "Refund",
//         transactionDate: new Date("2024-02-01")
//       }
//     ],
//     taxWithholdingTransfer: {
//       fundsMovementId: "funds3",
//       amount: 250.0,
//       status: PayoutStatus.Failed,
//       traceId: "trace3"
//     },
//     externalFundsTransfers: [
//       {
//         fundsMovementId: "funds4",
//         amount: 2250.0,
//         destination: {
//           destinationType: "BankAccount",
//           destinationId: "dest3",
//           name: "Company ABC",
//           institutionName: "Corporate Bank",
//           mask: "7890"
//         },
//         status: PayoutStatus.Complete,
//         traceId: "trace4"
//       }
//     ],
//     currency: "EUR",
//     payoutType: PayoutTypeEnum.Standard,
//     createdAt: new Date("2024-02-02"),
//     updatedAt: new Date("2024-02-03"),
//     retryCount: 0,
//     status: PayoutStatus.Complete,
//     events: {
//       processedAt: new Date("2024-02-04")
//     },
//     isSettlement: true,
//     settlementPeriodStart: new Date("2024-02-01"),
//     settlementPeriodEnd: new Date("2024-02-28"),
//     payoutSource: PayoutSource.AR,
//     userId: "user2"
//   }
// ];

const PROD_PAYOUT_ITEMS = [
  {
    sourceId: "KvxbhHF9GYDvwwfH5cr880",
    sourceType: "Leg",
    amount: 155150,
    description: "Coupa Pay from Velocity Global",
    _id: "66b4968e71bf7810dac1a2fe"
  },
  {
    sourceId: "o2KZ4xQ1FpyNZY1jfwBUDV",
    sourceType: "Leg",
    amount: 0.01,
    description: "ACCTVERIFY from Bill.com",
    _id: "66b4968e71bf7810dac1a300"
  },
  {
    sourceId: "wire_2ji3eRgUOvjIrWMzghAkFmYfKxT",
    sourceType: "LeadBank",
    amount: 1,
    description: "TEST from WINGSPAN NETWORKS, INC.",
    _id: "66b4968e71bf7810dac1a"
  },
  {
    sourceId: "NAldB_T9FJ5xmLWebZbE3V",
    sourceType: "Invoice",
    amount: 148.42,
    description: "AP Invoice",
    transactionDate: "2024-10-19T13:10:55.045+00:00",
    _id: "6715ab16a625c66dea9c46e1"
  },
  {
    sourceId: "5clh6mQ4H71NeCaprASdQV",
    sourceType: "Leg",
    amount: -59.64,
    description: "Tax Withholding"
  },
  {
    sourceId: "X6zGDi0nFoe3F_K7O0UtxF",
    sourceType: "Leg",
    amount: -400,
    description: "Banking"
  }
];

// const PROD_PAYOUTS = [
export const mockPayouts: Payout[] = [
  {
    _id: "VtEmkBWvIzuElZYQuGG3tV",
    userRoles: {
      ownerIds: ["9gyF9N0WI5qe4pb_0fuFlV"],
      viewerIds: ["9gyF9N0WI5qe4pb_0fuFlV"]
    },
    userId: "9gyF9N0WI5qe4pb_0fuFlV",
    payoutItems: [
      {
        sourceId: "GZxwp71EGKLDYaeWr0Tk6k",
        sourceType: "Invoice",
        amount: 585,
        description: "AP Invoice",
        transactionDate: new Date(1729298031280),
        _id: "6715aa54a625c66dea9b8261"
      },
      {
        sourceId: "Jh1U_A5HH8Hy3rV3B_mzck",
        sourceType: "Invoice",
        amount: 455,
        description: "AP Invoice",
        transactionDate: new Date(1729297988270),
        _id: "6715aa54a625c66dea9b8262"
      }
    ],
    currency: "USD",
    taxWithholdingTransfer: {},
    bankingFundsTransfer: {},
    retryCount: 0,
    events: {},
    isSettlement: true,
    settlementPeriodStart: new Date(1729202400000),
    settlementPeriodEnd: new Date(1729472400000),
    currentPeriodBalance: 1040,
    futureDebits: 0,
    payoutSource: "PayoutSource_AP",
    labels: {},
    eventActors: {
      createdBy: "SYSTEM"
    },
    externalFundsTransfers: [
      {
        fundsMovementId: "aS_8eFBiFzinK_mtUPT0uV",
        amount: 1040,
        destination: {
          destinationType: "DestinationType_Account",
          destinationId: "XCQ6ky8WIRyb48DJWXvzgF",
          name: "Invoice Payouts Account",
          institutionName: "Bank of America",
          mask: "9930"
        },
        _id: "6715aa58a625c66dea9b8739"
      }
    ],
    payoutId: "VtEmkBWvIzuElZYQuGG3tV",
    createdAt: new Date(1729473108205),
    updatedAt: new Date(1729473113753),
    __v: 1,
    status: "Clearing" as PayoutStatus
  },
  {
    _id: "Y1zixkLwGmqtG_QTn7cBDk",
    userRoles: {
      ownerIds: ["E0bzAc6UGt5SlWHDKIVjik"],
      viewerIds: ["E0bzAc6UGt5SlWHDKIVjik"]
    },
    userId: "E0bzAc6UGt5SlWHDKIVjik",
    payoutItems: [],
    currency: "USD",
    taxWithholdingTransfer: {},
    bankingFundsTransfer: {},
    retryCount: 0,
    events: {
      nextRetryAt: new Date(1729532087821),
      lastFailedAt: new Date(1729528488311)
    },
    isSettlement: false,
    currentPeriodBalance: 44.88,
    futureDebits: 0,
    payoutSource: "PayoutSource_AP",
    labels: {},
    eventActors: {
      createdBy: "UNKNOWN",
      nextRetryBy: "UNKNOWN",
      lastFailedBy: "UNKNOWN"
    },
    externalFundsTransfers: [
      {
        fundsMovementId: "ehlOqaB7IE9rw3JlbljwVV",
        amount: 44.88,
        destination: {
          destinationType: "DestinationType_Card",
          destinationId:
            "c6315d38dfa74ad5b963cfb7b42ac0c0:vHkOfawhQfksm02JUTe7VDTarGz9rU"
        },
        _id: "67168286ad901a1ec2440097"
      }
    ],
    payoutId: "Y1zixkLwGmqtG_QTn7cBDk",
    createdAt: new Date(1729528450329),
    updatedAt: new Date(1729528488319),
    __v: 1,
    status: "Failed" as PayoutStatus
  }
];

const PROD_CART = {
  _id: "xd8l0YyeIiX80On_7FudBF",
  labels: {},
  userRoles: {
    ownerIds: ["z084TRj_IdDj2b8XqQ8EhV"],
    viewerIds: ["z084TRj_IdDj2b8XqQ8EhV"]
  },
  createdAt: new Date(1727114000347),
  updatedAt: new Date(1727793290765),
  userId: "nQkN_xPGFnHcMw7v4SNW8V",
  expirationMonth: 9,
  expirationYear: 2030,
  mask: "",
  postalCode: "11238",
  country: "US",
  cardType: "Debit",
  issuer: "Wingspan",
  brand: "Visa",
  currency: "USD",
  internal: {
    moovPaymentMethods: {},
    lithicCardId: "c6924669-1dee-4d20-bed2-bb562312b2b7",
    internalAccountId: "1FiRImPgHBu0Mo9oelkPtV",
    closureInformation: {}
  },
  status: "Active",
  events: {
    cardCreatedAt: new Date(1727112905000),
    cardActivatedAt: new Date(1727544087983)
  },
  isVirtualCard: false,
  eventActors: {
    createdBy: "UNKNOWN",
    cardActivatedBy: "UNKNOWN"
  },
  paymentCardId: "xd8l0YyeIiX80On_7FudBF",
  __v: 0
};

const invoice1 = {
  _id: "MgOKNcLpILLBphgunGu1Xk",
  userRoles: {
    ownerIds: ["PVfEIzXDIHTLbsI2UEjzSV"],
    viewerIds: ["UvN7OQhBGJ1iyUbH5RQXc0", "PVfEIzXDIHTLbsI2UEjzSV"]
  },
  memberId: "UvN7OQhBGJ1iyUbH5RQXc0",
  memberClientId: "f_3AlSJoFradb0996nELKV",
  clientId: "PVfEIzXDIHTLbsI2UEjzSV",
  amount: 456,
  lineItems: [
    {
      description: "September 2024 Invoice",
      totalCost: 456,
      discount: {},
      _id: "dEgc0h6gFbm9zMwj00ZCKV",
      labels: {},
      createdAt: new Date(1728926691609),
      updatedAt: new Date(1728926691609)
    }
  ],
  processingFees: {
    instantPayoutFee: {
      amount: 4.56,
      calculatedAt: new Date(1729327230451)
    }
  },
  client: {
    payDate: new Date(1729512000000),
    workflowStatus: "Approved"
  },
  member: {},
  creditFeeHandling: {
    memberPays: 0,
    clientPays: 100
  },
  metadata: {},
  currency: "USD",
  acceptedPaymentMethods: ["Credit", "ACH", "Manual"],
  invoiceNotes: "",
  status: "Paid",
  dueDate: new Date(1729512000000),
  events: {
    paymentFailedAt: [],
    paymentRetriedAt: [],
    emailReceivedAt: [],
    emailViewedAt: [],
    sentManuallyAt: [],
    approvedAt: new Date(1728926691858),
    openedAt: new Date(1728926692006),
    sentAt: new Date(1728926693486),
    estimatedDepositAt: new Date(1729339200000),
    paidAt: new Date(1729327212916),
    instantPayoutAt: new Date(1729327234229),
    sentPaymentConfirmationToMember: new Date(1729327234730),
    depositedAt: new Date(1729512000000)
  },
  paymentInfo: {},
  attachments: {
    customAttachmentIds: [],
    invoiceLink:
      "https://my.wingspan.app/invoice-payment/MgOKNcLpILLBphgunGu1Xk",
    invoicePdf: "invoices/Invoice_MgOKNcLpILLBphgunGu1Xk.pdf",
    receiptPdf: "receipts/Receipt_MgOKNcLpILLBphgunGu1Xk.pdf"
  },
  memberAddress: {
    addressLine1: "10606 E 66th st",
    addressLine2: "Apt 266",
    city: "Tulsa",
    country: "US",
    postalCode: "74133",
    state: "OK"
  },
  notificationPreferences: {
    sendReminders: false
  },
  internal: {
    stripe: {
      handledEvents: {}
    },
    paymentsVersion: 2,
    events: {
      paymentDueAt: new Date(1729512000000),
      transitionedToPaid: new Date(1729327212916)
    },
    collaborators: {},
    paymentDetails: {},
    payroll: {
      payrollId: "nQVVNp2rHYTP4TtdX7Qj50"
    }
  },
  labels: {
    createdBy: "PVfEIzXDIHTLbsI2UEjzSV"
  },
  eventActors: {
    createdBy: "PVfEIzXDIHTLbsI2UEjzSV",
    approvedBy: "PVfEIzXDIHTLbsI2UEjzSV",
    openedBy: "PVfEIzXDIHTLbsI2UEjzSV",
    sentBy: "UNKNOWN",
    estimatedDepositBy: "PVfEIzXDIHTLbsI2UEjzSV",
    paidBy: "PVfEIzXDIHTLbsI2UEjzSV",
    instantPayoutBy: "PVfEIzXDIHTLbsI2UEjzSV",
    sentPaymentConfirmationToMemberBy: "PVfEIzXDIHTLbsI2UEjzSV",
    depositedBy: "SYSTEM"
  },
  collaborators: [],
  chargedFees: {},
  externalIds: {},
  bankTransferInfo: {},
  internationalBankTransferInfo: {},
  payments: [
    {
      labels: {},
      createdAt: new Date(1729327221825),
      updatedAt: new Date(1729327221825),
      paymentId: "WprBRkoZFyP4uqP6MHWylV",
      amount: 456,
      sourceType: "InternalAccount",
      sourceId: "mXrAIsNHGMichH6z_5PRFV",
      sourceMetadata: {
        institution: "AP"
      }
    }
  ]
};

const invoice2 = {
  _id: "QMkITSctHa1GOeO0sXn3fk",
  status: "Created",
  events: {},
  payoutDestinations: [
    {
      createdAt: new Date(1729472681248),
      updatedAt: new Date(1729472681248),
      amount: -456,
      destinationType: "Payout",
      destinationId: "K02b2Z2TFQqUU2XhO7C_ek",
      _id: "8c0wrQhMIw5ECDVE0k6cN0",
      labels: {}
    }
  ],
  refundDestinations: [],
  deductions: [],
  invoiceId: "MgOKNcLpILLBphgunGu1Xk",
  createdAt: new Date(1728926691609),
  updatedAt: new Date(1729472681345),
  __v: 0,
  invoiceNumber: "4BRFV-011",
  amountDetails: {
    clientPaid: -456,
    collaboratorPayments: 0,
    deductions: 0,
    memberGross: -456,
    memberNet: -456,
    memberTaxWithheld: 0,
    processingFee: 0,
    wingspanTopUp: 0
  },
  withholdings: {
    tax: {
      amountWithheld: 0,
      rate: 0
    }
  }
};
